import React from 'react'
import PropTypes from 'prop-types'
import Transition from 'react-transition-group/Transition'

const Fade = ({
                  in: inProp,
                  duration,
                  down,
                  delay,
                  children,
                  unmountOnHide,
                  appear,
                  ...props

              }) => {


    const defaultStyle = {
        transition: `all ${duration}ms ease ${delay}ms`,
        opacity: 0,
        transform: down ? 'translate3d(0, 5rem , 0 )' : '',
    }

    const transitionStyles = {
        entering: {
            opacity: 0,

        },
        entered: {
            opacity: 1,
            transform: down ? 'translate3d(0, 0rem , 0 )' : '',
        },
    }


    return (
        <Transition
            in={inProp}
            timeout={duration}
            unmountOnHide={unmountOnHide}
            appear={appear}
            >
            {(state) => (
                <div
                    style={{
                        ...defaultStyle,
                        ...transitionStyles[state],
                        ...props.style,
                    }}
                    >
                    {children}
                </div>
            )}
        </Transition>
    )
}


Fade.propTypes = {
    in: PropTypes.bool,
    style: PropTypes.object,
    down: PropTypes.bool,
    duration: PropTypes.number,
    delay: PropTypes.number,
    unmountOnHide: PropTypes.bool,
    appear: PropTypes.bool,
}

Fade.defaultProps = {
    in: false,
    down: true,
    duration: 300,
    delay: 0,
    unmountOnHide: false,
    appear: true,
}


export default Fade


// WEBPACK FOOTER //
// ./src/components/_common/_transitions/Fade/index.js